import {Component, ProfileOptionProps} from './types';
import React, {useCallback, useMemo} from 'react';

import AssignShopperCTA from '../AssignShopperCTA/AssignShopperCTA';
import {Box} from '../../../components/core/view';
import {Divider} from 'native-base';
import If from '@buncha/components/conditional/If';
import MainComponent from '../MainComponent';
import {useAppSelector} from '@buncha/config/redux/hooks';

const ProfileOptions = (props: ProfileOptionProps) => {
  const {listData} = props;
  const showAssignOrders = useAppSelector(
    state => state.onboarding.constants?.SHOW_ASSIGN_ORDERS,
  );

  const renderComponent = useCallback((component: Component) => {
    return <MainComponent component={component} />;
  }, []);

  const mainComponent = useCallback(
    (component: Component) => {
      const isDivider = Boolean(component.divider);
      if (isDivider) return <Divider />;
      return renderComponent(component);
    },
    [renderComponent],
  );

  const RenderItems = useMemo(() => {
    return listData?.map((component: Component) => {
      return mainComponent(component);
    });
  }, [mainComponent, listData]);

  return (
    <Box>
      <If condition={showAssignOrders === 'true'}>
        <AssignShopperCTA />
        <Divider />
      </If>
      <Box>{RenderItems}</Box>
    </Box>
  );
};

export default React.memo(ProfileOptions);
